import { useState } from 'react';
import { useCustom } from '@refinedev/core';
import { Card, Segmented } from 'antd';
import { Line } from '@ant-design/charts';
import { BOTTOM_LEGEND } from '@/pages/dashboard/chartLegend';
import type { DailyCountOut } from '@/api/generated/schemas';

const PERIODS = [
  { label: '7 dni', value: 7 },
  { label: '30 dni', value: 30 },
  { label: '90 dni', value: 90 },
];

const ACTIVE_LABEL = 'Aktywne';
const REVOKED_LABEL = 'Odwołane';

export const TokenActivity = () => {
  const [days, setDays] = useState(30);

  const { query: activeQuery } = useCustom<DailyCountOut[]>({
    url: 'iam/oauth_tokens/stats/active',
    method: 'get',
    config: { query: { days } },
  });

  const { query: revokeQuery } = useCustom<DailyCountOut[]>({
    url: 'iam/oauth_tokens/stats/revocations',
    method: 'get',
    config: { query: { days } },
  });

  const chartData = [
    ...(activeQuery.data?.data ?? []).map((d: DailyCountOut) => ({
      ...d,
      type: ACTIVE_LABEL,
    })),
    ...(revokeQuery.data?.data ?? []).map((d: DailyCountOut) => ({
      ...d,
      type: REVOKED_LABEL,
    })),
  ];

  return (
    <Card
      title="Aktywne sesje"
      extra={
        <Segmented
          options={PERIODS.map((p) => ({ label: p.label, value: p.value }))}
          value={days}
          onChange={(v) => setDays(v as number)}
        />
      }
      loading={activeQuery.isLoading || revokeQuery.isLoading}
    >
      <Line
        data={chartData}
        xField="date"
        yField="count"
        colorField="type"
        height={240}
        scale={{
          color: {
            domain: [ACTIVE_LABEL, REVOKED_LABEL],
            range: ['#1677ff', '#cf1322'],
          },
        }}
        legend={BOTTOM_LEGEND}
      />
    </Card>
  );
};
